import intl from "react-intl-universal";
import { IAuthService, SignUpParams } from "../../../../../platform/services/auth/AuthService";

import {GA_EVENTS, sendGAEvent} from "../../../../../utils/googleTagManager";

export const signUp = async (
    authService: IAuthService,
    signUpParams: SignUpParams,
    setErrors: (errors: any) => void,
) => {
    try {
        await authService.signUp(signUpParams);
        sendGAEvent(GA_EVENTS.SIGN_UP)
        return true;
    } catch (error: unknown) {
        sendGAEvent(GA_EVENTS.SIGN_UP_FAIL)

        if (error instanceof Error) {
            switch (error.name) {
                case 'NotAuthorizedException': {
                    setErrors({
                        email: intl.get('aws_api_error.NotAuthorizedException').d('Incorrect username or password.'),
                    });
                    break;
                }
                case 'InvalidParameterException': {
                    setErrors({
                        email: intl.get('aws_api_error.InvalidParameterException').d('Please enter your email address using the format name@example.com'),
                    });
                    break;
                }
                case 'UsernameExistsException': {
                    const loginLink = `<a
                        class="TextLink TextLink--error"
                        href="/sign-in"
                    >${intl.get('login.log_in_in_text').d('log in')}</a>`;
                    setErrors({
                        email: intl.getHTML('aws_api_error.UsernameExistsException', {loginLink}).d(`An account with this email already exists. If this is your account, ${loginLink}`),
                    });
                    break;
                }
                case 'InvalidPasswordException': {
                    setErrors({
                        password: intl.get('aws_api_error.InvalidPasswordException').d('Password field must contain at least 8 symbols.'),
                    });
                    break;
                }
                case 'UserLambdaValidationException': {
                    const errorMessage = error.message || ''; // Ensure error.message is not undefined

                    if (errorMessage.includes('captcha verification failed')) {
                        setErrors({
                            captcha: intl.get('aws_api_error.CaptchaFailed').d('CAPTCHA verification failed. Please try again.'),
                        });
                    } else if (errorMessage.includes('Invalid or mismatched captcha token')) {
                        setErrors({
                            captcha: intl.get('aws_api_error.CaptchaFailed').d('CAPTCHA verification failed. Please try again.'),
                        });
                    } else if (errorMessage.includes('User with this email already exists')) {
                        const loginLink = `<a class="TextLink TextLink--error" href="/sign-in">${intl.get('login.log_in_in_text').d('log in')}</a>`;

                        setErrors({
                            email: intl.getHTML('aws_api_error.UsernameExistsException', {loginLink}).d(`An account with this email already exists. If this is your account, ${loginLink}`),
                        });
                    } else if (errorMessage.includes('invite link is invalid or expired')) {
                        setErrors({
                            email: intl.get('aws_api_error.InviteLinkInvalidExpired').d('The invite link is invalid or has expired.'),
                        });
                    } else if (errorMessage.includes('rejected')) {
                        setErrors({
                            email: intl.get('aws_api_error.rejected').d('Registration rejected, please contact us if you believe that something went wrong.'),
                        });
                    } else {
                        setErrors({
                            email: intl.get('aws_api_error.UnknownLambdaError').d('An unexpected validation error occurred. Please try again.'),
                        });
                    }
                    break;
                }
                case 'CodeDeliveryFailureException': {
                    setErrors({
                        email: intl.get('aws_api_error.CodeDeliveryFailureException').d('Failed to deliver verification code. Please try again.'),
                    });
                    break;
                }
                case 'TooManyRequestsException': {
                    setErrors({
                        email: intl.get('aws_api_error.TooManyRequestsException').d('Too many attempts. Please try again later.'),
                    });
                    break;
                }
                case 'InternalErrorException': {
                    setErrors({
                        email: intl.get('aws_api_error.InternalErrorException').d('An internal server error occurred. Please try again later.'),
                    });
                    break;
                }
                default:
                    setErrors({
                        email: error.message || intl.get('aws_api_error.authentication.default').d('An unexpected authentication error occurred.'),
                    });
            }
        } else if (error instanceof Error) {
            setErrors({
                email: error.message || intl.get('aws_api_error.default').d('An unexpected error occurred.'),
            });
        } else {
            setErrors({
                email: intl.get('aws_api_error.unknown').d('An unknown error occurred.'),
            });
        }

        return false;
    }
}